<template>
  <div class="padding-vertical-big">
    <div class="display-flex justify-content-between">
      <div v-if="taskId">
        <h2 class="bold ink-base font-size-xbig">{{ title }}</h2>
        <p class="normal ink-lighter-1 font-size-big">{{ description }}</p>
      </div>

      <div v-else>
        <h2 class="bold ink-base font-size-xbig">Nova etapa</h2>
      </div>

      <BButton
        :loading="loading"
        class="font-size-big"
        @clickOrEnter="handleSubmit()"
      >
        Salvar alterações
      </BButton>
    </div>

    <div class="row margin-vertical-big" v-if="!loading">
      <div class="form-column col-sm-12 col-md-12 col-lg-5 padding-right-normal">
        <BCard class="w100 padding-horizontal-big padding-vertical-big margin-bottom-tiny">
          <div class="row">
            <div class="col-md-7 col-12">
              <BInput
                class="margin-vertical-normal padding-right-normal display-block font-size-big"
                type="text"
                placeholder="Definição de objetivos do produto"
                name="title"
                label="Nome da etapa"
                v-model="title"
                :error="errors.title"
                @input="errors.title = ''"
              />
            </div>
            <div class="col-md-5 col-12">
              <BDatepicker
                name="dueDate"
                :error="errors.dueDate"
                @input="errors.dueDate = ''"
                class="margin-vertical-normal display-block font-size-big"
                v-model="dueDate"
              >
                <div slot="label">
                  <p class="font-size-big semi-bold margin-top-0 ink-base margin-bottom-normal">
                    Prazo da etapa
                  </p>
                </div>
              </BDatepicker>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 col-12">
              <BInput
                class="margin-vertical-normal display-block font-size-big"
                type="text"
                placeholder="Consolidar a estratégia do produto."
                name="description"
                label="Objetivo da etapa"
                v-model="description"
                :error="errors.description"
                @input="errors.description = ''"
              />
            </div>
          </div>
        </BCard>
      </div>

      <div class="form-column col-sm-12 col-md-12 col-lg-7 padding-left-normal">
        <SubTaskFields
					:assignUsers="assignUsers"
          :subTasks="subTasks"
          @updated="subTasksUpdated => (subTasks = subTasksUpdated)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { BCard, BButton, BInput, BDatepicker } from '@bossabox-code/design-system';
import SubTaskFields from './components/SubTaskFields.vue';

export default {
	name: 'TaskForm',
	components: {
		BCard,
		BButton,
		BInput,
		BDatepicker,
		SubTaskFields
	},
	props: {
		task: {
			type: Object,
			required: false
		},
		loading: {
			type: Boolean,
			default: false
		},
		resetFieldsOnSubmit: {
			type: Boolean,
			default: true
		},
		assignUsers: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			errors: [],
			taskId: null,
			title: null,
			dueDate: null,
			description: null,
			subTasks: []
		};
	},
	mounted() {
		if (this.task && this.task._id) {
			this.taskId = this.task._id;
			this.title = this.task.title;
			this.dueDate = new Date(this.task.dueDate);
			this.description = this.task.description;
			this.subTasks = this.task.subTasks;
		} else if (this.resetFieldsOnSubmit)  {
			this.resetFields();
		}
	},
	methods: {
		resetFields() {
			this.title = null;
			this.dueDate = null;
			this.description = null;
			this.subTasks = [];
		},
		validateForm() {
			this.errors = {};

			if (!this.title) Vue.set(this.errors, 'title', 'Essa informação é obrigatória');
			if (!this.dueDate) Vue.set(this.errors, 'dueDate', 'Essa informação é obrigatória');
			if (!this.description) Vue.set(this.errors, 'description', 'Essa informação é obrigatória');

			if (Object.keys(this.errors).length == 0) return true;
		},
		async handleSubmit() {
			if (this.validateForm()) {
				const taskData = {
					title: this.title,
					dueDate: this.dueDate,
					description: this.description,
					subTasks: this.subTasks
				};

				this.$emit('submited', taskData);
				this.resetFieldsOnSubmit && this.resetFields();
			}
		}
	}
};
</script>

<style scoped lang="scss">
@import '@bossabox-code/design-system/css/spacing.scss';

.avatar {
	float: left;
}

@media screen and (max-width: map-get($breakpoints, 'lg')) {
	.form-column {
		padding-right: 0;
		padding-left: 0;
	}
}
</style>
